import React from 'react';
import Landing from '../landing/';
import About from '../about';
import Strategies from '../strategies';
import Sectors from '../sectors';
import Geographic from '../geographic';
import ScrollToTop from './scroll-to-top';
import { BrowserRouter as Router, Route } from 'react-router-dom';

const Root = () => (
  <Router>
    <ScrollToTop>
      <Route exact path="/" component={Landing} />
      <Route exact path="/about" component={About} />
      <Route exact path="/strategies" component={Strategies} />
      <Route exact path="/sectors" component={Sectors} />
      <Route exact path="/geographic" component={Geographic} />
    </ScrollToTop>
  </Router>
);

export default Root;



// WEBPACK FOOTER //
// ./src/pages/root/root.js